<template>
  <div class="about-page">
    <header class="about-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>
        {{ $t('shopds.help') }}
      </h1>
    </header>

    <main class="about-main">
      <section class="settings-card">
        <router-link
          v-for="(v,k) in data.list"
          :key="k"
          :to="'about/' + v.id"
          class="setting-row"
        >
          <span
            class="setting-icon"
            :class="'tone-' + (k % 6)"
          >
            <van-icon name="description" />
          </span>
          <span class="setting-label">{{ v['title_'+lang] }}</span>
          <van-icon
            class="row-arrow"
            name="arrow"
          />
        </router-link>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: 'About',
  data() {
    return {
      lang: this.$i18n.locale || 'zh_cn',
      show_icon_type: 'about',
      data: {
        list: [],
      },
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/about').then((r) => {
        this.data = r.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.about-page {
  min-height: 100vh;
  padding-bottom: 18px;
  box-sizing: border-box;
  background: #f4f5fb;
  color: #061429;
}

.about-header {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fd;
}

.about-header h1 {
  margin: 0;
  color: #202637;
  font-size: 14px;
  font-weight: 500;
  line-height: 58px;
}

.back-btn {
  position: absolute;
  left: 8px;
  top: 10px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #071426;
  font-size: 22px;
}

.about-main {
  padding: 16px 16px 88px;
}

.settings-card {
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
}

.setting-row {
  min-height: 70px;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 16px;
  align-items: center;
  column-gap: 14px;
  margin: 0 20px;
  border-bottom: 1px solid #edf0f6;
  color: #1f2b44;
  text-decoration: none;
  box-sizing: border-box;
}

.setting-row:last-child {
  border-bottom: 0;
}

.setting-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
}

.tone-0 {
  background: linear-gradient(135deg, #6199ff 0%, #246cf2 100%);
}

.tone-1 {
  background: linear-gradient(135deg, #42d7dc 0%, #17a8cc 100%);
}

.tone-2 {
  background: linear-gradient(135deg, #70d87b 0%, #2fac59 100%);
}

.tone-3 {
  background: linear-gradient(135deg, #ffbd61 0%, #ff8e2b 100%);
}

.tone-4 {
  background: linear-gradient(135deg, #9a86ff 0%, #7662f7 100%);
}

.tone-5 {
  background: linear-gradient(135deg, #a8b2c1 0%, #737f91 100%);
}

.setting-label {
  min-width: 0;
  overflow: hidden;
  color: #243049;
  font-size: 14px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-arrow {
  color: #c4cad4;
  font-size: 16px;
}
</style>
